import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { Lead } from '@/types/lead';

interface ConvertToJobResult {
  lead: Lead;
  jobId: string;
}

export function useConvertLeadToJob() {
  const queryClient = useQueryClient();

  return useApiMutation<ConvertToJobResult, string>({
    mutationFn: (leadId) =>
      apiPost<ConvertToJobResult>(operationsClient, leadEndpoints.convertToJob(leadId)),
    onSuccess: (data, leadId) => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.detail(leadId) });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead converted to job');
    },
  });
}
